
import { TranslateService } from "@ngstack/translate";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit, Inject } from "@angular/core";
import * as moment from "jalali-moment";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-discount-group-person-status',
  templateUrl: './discount-group-person-status.component.html',
  styleUrls: ['./discount-group-person-status.component.css']
})
export class DiscountGroupPersonStatusComponent implements OnInit {

  param: any;
  personInfo: any;
  errObject: any;
  form: FormGroup;
  errors = new Array();

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<DiscountGroupPersonStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      ValidityEndDate: [null, this.data ? Validators.required : null],
      Description: [null, !this.data ? Validators.required : null],
      IsAcceptedDocument: [null]
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit(form: any) {

    this.errors = new Array();
    if (form && form.ValidityEndDate) {
      form.ValidityEndDate = moment
        .from(form.ValidityEndDate, "en")
        .utc(true)
        .format(environment.dateFormat);
      //.toJSON();
    }
    this.dialogRef.close(form);

  }

}
